import { find } from 'lodash';

export default function getSubscriptionInfo(merchantId) {
  const merchantSubscriptions = JSON.parse(localStorage.getItem('merchantSubscriptions'));
  if (merchantSubscriptions && merchantSubscriptions.length) {
    return find(merchantSubscriptions, { id: merchantId });
  }

  return false;
}
